module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro5.435a72f7.mp3";